<template>
  <v-layout row wrap>
    <AuditItemDialog :dialogAuditItem.sync="dialogAuditItem" v-if="dialogAuditItem" />
    <AuditFindingDialog
      :current-audit-item="currentAuditItem"
      :dialogDeviation.sync="dialogDeviation"
      v-if="dialogDeviation"
    />

    <AuditProcessContainer>
      <AuditProgress slot="container_progress" :auditProgress="auditProgress" />

      <GroupableItemList
        slot="container_content"
        :list-items="auditItems"
        list-config-key="auditExecution"
        :manipulators="auditItemManipulators"
      >
        <template v-slot:default="{ item }">
          <AuditItemRow :key="item.id">
            <ItemLayout
              slot="question"
              :severity="getSeverity(item.question.importance, 'audititem')"
              highlight-field-display-name="value"
              type="question"
            >
              <AuditQuestionComponent
                slot="content"
                :question="item.question"
                :standard-id="currentAudit.standard"
              />

              <AuditProcessMenu
                v-if="hover"
                slot="actions"
                slot-scope="{ hover }"
                :actions="getAuditItemActions"
                :context="{ref: {auditId, auditItemId: item.id}}"
                @itemdelete="deleteCurrentAuditItem(auditId, item.id)"
                @itemupdate="updateCurrentAuditItem(auditId, item.id, item)"
              />
            </ItemLayout>

            <ItemLayout
              v-for="(deviation,deviation_index) in item.deviations"
              :key="deviation_index"
              slot="findings"
              :severity="getSeverity(deviation.importance, 'finding')"
              highlight-field-display-name="value"
              type="finding"
            >
              <AuditFindingComponent
                slot="content"
                :context="{ref: {auditId, auditItemId: item.id, findingId: deviation_index}}"
                :deviation="deviation"
              />

              <template slot="actions" slot-scope="{ hover }">
                <AuditProcessMenu
                  v-if="hover"
                  :actions="item.deactivated ? getDeactivatedAuditItemActions : getFindingActions"
                  :context="{ref: {auditId, auditItemId: item.id, findingId: deviation_index}}"
                  @itemupdate="openFindingDialog"
                  @itemcamera="callCamera"
                  @itemattach="pickFile(auditId, item.id, deviation_index)"
                />
              </template>
            </ItemLayout>

            <CreateFinding
              v-if="!item.deactivated && !item.completed && !item.checked"
              slot="createfinding"
              :audit-id="auditId"
              :audit-item-id="item.id"
              attachment
              dialog
              @open-finding-dialog="openFindingDialog"
              @attachment-create-finding="createCurrentDeviationAttach"
            />
          </AuditItemRow>
        </template>
      </GroupableItemList>
    </AuditProcessContainer>

    <input type="file" style="display:none;" ref="image" accept="image/*" @change="onFilePicked" />

    <input
      type="file"
      style="display:none;"
      ref="quickattach"
      accept="image/*"
      @change="onAttachmentPicked"
    />

    <v-btn fab bottom right color="pink" dark fixed @click="createCurrentAuditItem(auditId)">
      <v-icon>add</v-icon>
    </v-btn>
  </v-layout>
</template>

<i18n>
{
  "de": {
    "auditfinding_header": "Feststellung",
    "audititem_header": "Auditfrage",
    "category_label": "Kategorie",
    "chapters_label": "Zugeordnete Normkapitel",
    "importance_label": "Bedeutung",
    "auditfinding_actions": "Aktionen",
    "audit_progress": "Fortschritt der Auditdurchführung",
    "finding_9": "Hauptabweichung",
    "finding_3": "Nebenabweichung",
    "finding_1": "Anmerkung",
    "finding_0": "Bemerkung",
    "cancel": "Abbrechen",
    "save": "Speichern"
  },
  "en": {
    "audititem_title": "Audit Question",
    "audit_progress": "Audit progress",
    "category_label": "Category",
    "chapters_label": "Assigned Standard Chapters",
    "importance_label": "Importance",
    "cancel": "Cancel",
    "save": "Save"   
  }
}
</i18n>

<script>
// Dialogs
import AuditItemDialog from "@/components/dialogs/AuditItemDialog.vue";
import AuditFindingDialog from "@/components/dialogs/AuditFindingDialog.vue";

// Layouts
import AuditProcessContainer from "@/components/layouts/BaseLayouts/AuditProcessContainer.vue";
import AuditItemRow from "@/components/layouts/AuditExecution/AuditItemRow.vue";
import ItemLayout from "@/components/layouts/BaseLayouts/ItemLayout.vue";
import GroupableItemList from "@/components/layouts/BaseLayouts/GroupableItemList";

// Controls/Snippets
import AuditProgress from "@/components/snippets/AuditProgress.vue";
import CreateFinding from "@/components/controls/CreateFinding.vue";
import AuditProcessMenu from "@/components/controls/AuditProcessMenu.vue";

// Components
import AuditQuestionComponent from "@/components/widgets/AuditQuestionComponent.vue";
import AuditFindingComponent from "@/components/widgets/AuditFindingComponent.vue";

// Mixins
import FileUploaderMixin from "@/components/mixins/FileUploaderMixin.vue";
import AuditItemListMixin from "@/components/mixins/AuditItemListMixin";

import { mapGetters } from "vuex";
import { api as confApi } from "@/store/modules/configuration";

export default {
  components: {
    AuditItemDialog,
    AuditFindingDialog,
    AuditProcessContainer,
    AuditItemRow,
    ItemLayout,
    AuditProgress,
    AuditQuestionComponent,
    AuditFindingComponent,
    CreateFinding,
    AuditProcessMenu,
    GroupableItemList
  },
  mixins: [AuditItemListMixin, FileUploaderMixin],
  data() {
    return {
      dialogAuditItem: false,
      dialogDeviation: false
    };
  },
  computed: {
    ...mapGetters(confApi.namespace, [
      confApi.getters.audit,
      confApi.getters.getFindingActions,
      confApi.getters.getAuditItemActions,
      confApi.getters.getDeactivatedAuditItemActions
    ]),

    isGroupingActive() {
      return this.audit.dialog.auditprocess_lists_grouped || false;
    }
  }
};
</script>
